export default __webpack_public_path__ + "static/media/whatsapp.4ba01ee1.png";